// colorThemes.ts
import { red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal, green, lightGreen, lime, yellow, amber, orange, deepOrange, brown, grey, blueGrey } from '@mui/material/colors';

export type ColorTheme =
    | 'red'
    | 'pink'
    | 'purple'
    | 'deepPurple'
    | 'indigo'
    | 'blue'
    | 'green'
    | 'amber'
    | 'orange'
    | 'lightBlue'
    | 'cyan'
    | 'teal'
    | 'lightGreen'
    | 'lime'
    | 'yellow'
    | 'deepOrange'
    | 'brown'
    | 'grey'
    | 'blueGrey';

export const colorThemes = {
    red: {
        primary: red,
        secondary: amber,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    pink: {
        primary: pink,
        secondary: red,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    purple: {
        primary: purple,
        secondary: cyan,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    deepPurple: {
        primary: deepPurple,
        secondary: indigo,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    blue: {
        primary: blue,
        secondary: cyan,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    green: {
        primary: green,
        secondary: blue,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    amber: {
        primary: amber,
        secondary: brown,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    orange: {
        primary: orange,
        secondary: amber,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    lightBlue: {
        primary: lightBlue,
        secondary: cyan,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    cyan: {
        primary: cyan,
        secondary: lightBlue,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    teal: {
        primary: teal,
        secondary: cyan,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    lightGreen: {
        primary: lightGreen,
        secondary: green,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    lime: {
        primary: lime,
        secondary: lightGreen,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    yellow: {
        primary: yellow,
        secondary: amber,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    deepOrange: {
        primary: deepOrange,
        secondary: orange,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    brown: {
        primary: brown,
        secondary: orange,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    grey: {
        primary: grey,
        secondary: blueGrey,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    blueGrey: {
        primary: blueGrey,
        secondary: grey,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
    indigo: {
        primary: indigo,
        secondary: deepPurple,
        success: green,
        warning: amber,
        error: red,
        info: blue,
    },
};
